declare global {
  interface Window {
    REACT_APP_BASE_URL: string;
    REACT_APP_PARTICIPANT_URL: string;
    REACT_APP_WELCOME_VIDEO_URL: string;
    REACT_APP_GA_ID: string;
    REACT_APP_GADS_CONVERSION_SIGNUP: string;
    REACT_APP_AMPLITUDE_KEY: string;
  }
}

export const baseUrl =
  window.REACT_APP_BASE_URL || process.env.REACT_APP_BASE_URL || "";

export const participantPortalUrl =
  window.REACT_APP_PARTICIPANT_URL ||
  process.env.REACT_APP_PARTICIPANT_URL ||
  "";

export const welcomeVideoURL =
  window.REACT_APP_WELCOME_VIDEO_URL ||
  process.env.REACT_APP_WELCOME_VIDEO_URL ||
  "";

export const gaID = window.REACT_APP_GA_ID || process.env.REACT_APP_GA_ID || "";

export const googleAdsConversionSignUp =
  window.REACT_APP_GADS_CONVERSION_SIGNUP ||
  process.env.REACT_APP_GADS_CONVERSION_SIGNUP ||
  "";

export const amplitudeKey =
  window.REACT_APP_AMPLITUDE_KEY || process.env.REACT_APP_AMPLITUDE_KEY || "";
